/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSpecialHourResponse } from './CreateSpecialHourResponse';
import {
    CreateSpecialHourResponseFromJSON,
    CreateSpecialHourResponseFromJSONTyped,
    CreateSpecialHourResponseToJSON,
    CreateSpecialHourResponseToJSONTyped,
} from './CreateSpecialHourResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateSpecialHourResponse
 */
export interface ResultOfCreateSpecialHourResponse {
    /**
     * 
     * @type {CreateSpecialHourResponse}
     * @memberof ResultOfCreateSpecialHourResponse
     */
    data: CreateSpecialHourResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateSpecialHourResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateSpecialHourResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateSpecialHourResponse interface.
 */
export function instanceOfResultOfCreateSpecialHourResponse(value: object): value is ResultOfCreateSpecialHourResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateSpecialHourResponseFromJSON(json: any): ResultOfCreateSpecialHourResponse {
    return ResultOfCreateSpecialHourResponseFromJSONTyped(json, false);
}

export function ResultOfCreateSpecialHourResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateSpecialHourResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateSpecialHourResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateSpecialHourResponseToJSON(json: any): ResultOfCreateSpecialHourResponse {
    return ResultOfCreateSpecialHourResponseToJSONTyped(json, false);
}

export function ResultOfCreateSpecialHourResponseToJSONTyped(value?: ResultOfCreateSpecialHourResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateSpecialHourResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

